/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./../Layout/Header";
import Footer from "./../Layout/Footer";
import CountUp from "react-countup";
import IndexBanner from "./../Element/IndexBanner";
import Jobcategories from "./../Element/Jobcategories";

import Owltestimonial from "./../Element/Owlblog1";
import Banners from "../Element/Banners";
import Banner from "../Element/Banner";
import { FAQ } from "../Element/FAQ";
import Swal from "sweetalert2";
import axios from "axios";
import BaseUrl from "../../BaseUrl";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//Images
var bnr2 = require("./../../images/background/bg4.jpg");
var bnr3 = require("./../../images/lines.png");

function Homepage() {
  useEffect(() => {
    const prevPath = window.sessionStorage.getItem("prevPath");
    const previd = window.sessionStorage.getItem("previd");
    const prevemail = window.sessionStorage.getItem("prevemail");
    const prevuserid = window.sessionStorage.getItem("prevuserid");
    if (
      prevPath === `/Checkout/${previd}/${prevemail}/${prevuserid}` &&
      window.location.pathname === "/"
    ) {
      window.location.reload();
      window.sessionStorage.removeItem("prevPath");
    } else {
    }
  }, []);
  let users = localStorage.getItem("userDetails", "user");
  users = JSON.parse(users);
  console.log(users, "user");

  const [plans, setPlans] = useState([]);

  const Packages = () => {
    // setLoader(true);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/plans/index`,
    };

    axios(config)
      .then(function (response) {
        setPlans(response?.data);
      })
      .catch(function (error) {
        console.log(error?.response);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error.response.data.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  useEffect(() => {
    Packages();
  }, []);

  const settings = {
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: plans?.plans?.length > 3 ? 3 : 1,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="page-wraper">
      <Header />
      <div className="page-content">
        <IndexBanner />
        <div className="section-full job-categories content-inner-2 bg-white">
          <div className="container">
            <div className="section-head d-flex head-counter clearfix">
              <div className="mr-auto">
                <h2 className="m-b5">Popular Categories</h2>
                <h6 className="fw3">20+ Catetories work wating for you</h6>
              </div>
              <div className="head-counter-bx">
                <h2 className="m-b5 counter">
                  <CountUp end={1800} duration={10} />
                </h2>
                <h6 className="fw3">Jobs Posted</h6>
              </div>
              <div className="head-counter-bx">
                <h2 className="m-b5 counter">
                  <CountUp end={4500} duration={10} />
                </h2>
                <h6 className="fw3">Tasks Posted</h6>
              </div>
              <div className="head-counter-bx">
                <h2 className="m-b5 counter">
                  <CountUp end={1500} duration={10} />
                </h2>
                <h6 className="fw3">Freelancers</h6>
              </div>
            </div>
            <Jobcategories />
          </div>
        </div>
        <Banners />
        {/* PRicing */}
        <div
          className="section-full content-inner-2 overlay-white-middle"
          style={{
            backgroundImage: "url( " + bnr3 + ")",
            backgroundPosition: "bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
          }}
        >
          <div className="container">
            <div className="section-head text-black text-center">
              <h2 className="m-b0">Membership Plans</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy.
              </p>
            </div>

            <Slider {...settings}>
              {plans?.plans
                ? plans?.plans?.map((e, i) => {
                    return (
                      <>
                        {i % 2 === 0 ? (
                          <>
                            <div className="offset-md-1 col-md-10 offset-md-1 ">
                              <div className="pricingtable-wrapper style2 bg-white">
                                <div className="pricingtable-inner">
                                  <div className="pricingtable-price">
                                    <h4 className="font-weight-300 m-t10 m-b0">
                                      {e?.name}
                                    </h4>
                                    <div className="pricingtable-bx">
                                      $ <span>{e?.price}</span> / Per&nbsp;
                                      {e?.duration}&nbsp;{e?.period}{" "}
                                    </div>
                                  </div>
                                  <p>{e?.description}</p>
                                  <div className="m-t20">
                                    <Link
                                      to={`/register/${e?.slug}`}
                                      className="site-button radius-xl"
                                    >
                                      <span className="p-lr30">Sign Up</span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                        {i % 2 !== 0 ? (
                          <>
                            <div className="offset-md-1 col-md-10 offset-md-1">
                              <div className="pricingtable-wrapper style2 bg-primary text-white active">
                                <div className="pricingtable-inner">
                                  <div className="pricingtable-price">
                                    <h4 className="font-weight-300 m-t10 m-b0">
                                      {e?.name}
                                    </h4>
                                    <div className="pricingtable-bx">
                                      $ <span>{e?.price}</span> / Per&nbsp;
                                      {e?.duration}&nbsp;{e?.period}{" "}
                                    </div>
                                  </div>
                                  <p>{e?.description}</p>
                                  <div className="m-t20">
                                    <Link
                                      to={`/register/${e?.slug}`}
                                      className="site-button white radius-xl"
                                    >
                                      <span className="text-primary p-lr30">
                                        Sign Up
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </>
                    );
                  })
                : null}

              {/* <div className="col-sm-12 col-md-12 col-lg-12 p-lr0">
                <div className="pricingtable-wrapper style2 bg-white">
                  <div className="pricingtable-inner">
                    <div className="pricingtable-price">
                      <h4 className="font-weight-300 m-t10 m-b0">Extended</h4>
                      <div className="pricingtable-bx">
                        {" "}
                        $ <span>29</span> / Per Installation{" "}
                      </div>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet adipiscing elit sed do eiusmod
                      tempors labore et dolore magna siad enim aliqua
                    </p>
                    <div className="m-t20">
                      <Link to={"/register"} className="site-button radius-xl">
                        <span className="p-lr30">Sign Up</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div> */}
            </Slider>
          </div>
        </div>
        {/* Pricing */}
        <Banner />
        <div
          className="section-full p-tb70 overlay-black-dark text-white text-center bg-img-fix"
          style={{ backgroundImage: "url(" + bnr2 + ")" }}
        >
          <div className="container">
            <div className="section-head text-center text-white">
              <h2 className="m-b5">Testimonials</h2>
              <h5 className="fw4">Few words from candidates</h5>
            </div>
            <Owltestimonial />
          </div>
        </div>
        <div className="mt-5">
          <FAQ />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Homepage;
